import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import sanitizeItemContextMetadata from './sanitizeItemContextMetadata'
import { sum } from 'lib/array/arrayUtils'
import uuidV4 from 'lib/string/uuidV4Utils'

function getPaymentFeeOrderItems(order: App.Order) {
  const items = [] as Array<ReturnType<typeof comluxgroup.createItem_1_1_0>>

  if (order.merchantFees && order.merchantFees.length > 0) {
    const merchantFeeTotal = sum(order.merchantFees, fees => fees.amount)
    items.push(
      comluxgroup.createItem_1_1_0({
        categoryId: 'fee',
        productId: 'merchant_fee',
        currency: order.currencyCode,
        price: merchantFeeTotal,
        bookingNumber: order.bookingNumber,
        itemId: uuidV4(),
        orderId: order.id,
        offerId: '',
      }),
    )
  }

  if (order.serviceFee) {
    const { total, percentage, status, metadata, id } = order.serviceFee
    items.push(
      comluxgroup.createItem_1_1_0({
        categoryId: 'fee',
        productId: 'service_fee',
        currency: order.currencyCode,
        price: total,
        bookingNumber: order.bookingNumber,
        itemId: id,
        orderId: order.id,
        offerId: '',
        metadata: sanitizeItemContextMetadata({
          ...metadata,
          percentage,
          status,
        }),
      }),
    )
  }

  return items
}

export default getPaymentFeeOrderItems
